type PollProps<T> = {
  fn: () => Promise<T>;
  validate: (fnResult: T) => boolean;
  maxAttempts?: number;
  interval?: number;
};

export default async <T = any>({fn, validate, maxAttempts = 0, interval = 1000}: PollProps<T>): Promise<T> => {
  let attempts = 0;

  const executePoll = (resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises, consistent-return
    (async () => {
      try {
        const result: T = await fn();
        attempts += 1;

        if (validate(result)) {
          return resolve(result);
        } else if (maxAttempts && attempts === maxAttempts) {
          return reject(new Error('Exceeded max attempts'));
        } else {
          setTimeout(executePoll, interval, resolve, reject);
        }
      } catch (error) {
        reject(error);
      }
    })();
  };

  return new Promise(executePoll);
};
